import { render, staticRenderFns } from "./CollageOrder.vue?vue&type=template&id=b3181ece&scoped=true"
import script from "./CollageOrder.vue?vue&type=script&lang=js"
export * from "./CollageOrder.vue?vue&type=script&lang=js"
import style0 from "./CollageOrder.vue?vue&type=style&index=0&id=b3181ece&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3181ece",
  null
  
)

export default component.exports